// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   closeModal,
//   setBookingField,
//   setQty,
//   setCurrency,
//   createCheckoutSession,
//   selectBookingForm,
//   selectCheckoutStatus,
//   selectCheckoutError,
//   selectSelectedTour,
// } from "../Paneltours/PanelTourSlice/PanelTourSlice";

// const MISSION_NAMES = {
//   "the-strip" : "THE STRIP",
//   downtown    : "DOWNTOWN",
//   "red-rock"  : "RED ROCK",
//   "lake-lv"   : "LAKE LV",
// };

// const CURRENCIES = [
//   { code: "usd", label: "USD — US Dollar"        },
//   { code: "eur", label: "EUR — Euro"              },
//   { code: "gbp", label: "GBP — British Pound"     },
//   { code: "cad", label: "CAD — Canadian Dollar"   },
//   { code: "aud", label: "AUD — Australian Dollar" },
//   { code: "inr", label: "INR — Indian Rupee"      },
//   { code: "aed", label: "AED — UAE Dirham"        },
// ];

// const CCY_SYMBOL = {
//   usd: "$", eur: "€", gbp: "£", cad: "CA$",
//   aud: "A$", inr: "₹", aed: "AED ",
// };

// export default function MissionModal({ savedCallsign = "", savedEmail = "" }) {
//   const dispatch      = useDispatch();
//   const form          = useSelector(selectBookingForm);
//   const tour          = useSelector(selectSelectedTour);
//   const status        = useSelector(selectCheckoutStatus);
//   const checkoutError = useSelector(selectCheckoutError);

//   const loading    = status === "loading";
//   const sym        = CCY_SYMBOL[form.currency] ?? "$";
//   const totalPrice = tour ? tour.price * form.qty : 0;

//   // Pre-fill from driver profile
//   useEffect(() => {
//     if (savedCallsign && !form.callsign) {
//       dispatch(setBookingField({ field: "callsign", value: savedCallsign }));
//     }
//     if (savedEmail && !form.email) {
//       dispatch(setBookingField({ field: "email", value: savedEmail }));
//     }
//   }, [savedCallsign, savedEmail]); // eslint-disable-line

//   // Lock body scroll when modal open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => { document.body.style.overflow = ""; };
//   }, []);

//   if (!tour) return null;

//   const handleProceed = async () => {
//     if (!form.terms) {
//       dispatch(setBookingField({
//         field : "error",
//         value : "Please agree to the Terms of Service and Liability Waiver.",
//       }));
//       return;
//     }
//     if (!form.email.trim() || !form.email.includes("@")) {
//       dispatch(setBookingField({
//         field : "error",
//         value : "A valid email address is required.",
//       }));
//       return;
//     }

//     const result = await dispatch(createCheckoutSession({
//       tourId   : tour.id,
//       tourName : MISSION_NAMES[tour.id] || tour.name,
//       priceUsd : tour.price,
//       qty      : form.qty,
//       callsign : form.callsign,
//       email    : form.email,
//       currency : form.currency,
//     }));

//     if (createCheckoutSession.fulfilled.match(result)) {
//       window.location.href = result.payload.url;
//     }
//   };

//   return (
//     <div
//       className="vk-modal-overlay"
//       onClick={(e) => e.target === e.currentTarget && dispatch(closeModal())}
//     >
//       <div className="vk-modal-panel">

//         {/* Close */}
//         <button
//           className="vk-modal-close"
//           onClick={() => dispatch(closeModal())}
//           aria-label="Close"
//         >✕</button>

//         {/* Header */}
//         <div className="vk-modal-eyebrow">✓ MISSION ACCEPTED</div>
//         <h3 className="vk-modal-title">{MISSION_NAMES[tour.id] || tour.name}</h3>

//         {/* Price + Qty */}
//         <div className="vk-modal-price-row">
//           <div className="vk-modal-price">
//             {sym}{totalPrice}
//             <span className="vk-modal-price-sub"> // PRE-ORDER</span>
//           </div>

//           <div className="vk-modal-qty-wrap">
//             <button
//               className="vk-qty-btn"
//               onClick={() => dispatch(setQty(form.qty - 1))}
//               disabled={form.qty <= 1}
//             >−</button>
//             <span className="vk-qty-val">{form.qty}</span>
//             <button
//               className="vk-qty-btn"
//               onClick={() => dispatch(setQty(form.qty + 1))}
//               disabled={form.qty >= 10}
//             >+</button>
//             <span className="vk-qty-label">DRIVER{form.qty > 1 ? "S" : ""}</span>
//           </div>
//         </div>

//         {/* Info */}
//         <p className="vk-modal-body">
//           This is a <strong>pre-order</strong>. You are reserving your slot for{" "}
//           <strong>Winter 2026 deployment</strong>. Scheduling will be communicated
//           via your driver inbox after launch.
//         </p>
//         <p className="vk-modal-body">
//           A valid driver's license (18+) is required at time of experience.
//           Full refund available up to 30 days after purchase.
//         </p>

//         {/* Form */}
//         <div className="vk-modal-form">
//           <input
//             className="vk-form-input"
//             placeholder="CALLSIGN (optional)"
//             maxLength={20}
//             value={form.callsign}
//             onChange={(e) =>
//               dispatch(setBookingField({
//                 field : "callsign",
//                 value : e.target.value.toUpperCase().replace(/[^A-Z0-9\s_-]/g, ""),
//               }))
//             }
//           />

//           <input
//             type="email"
//             className="vk-form-input"
//             placeholder="EMAIL ADDRESS *"
//             required
//             value={form.email}
//             onChange={(e) =>
//               dispatch(setBookingField({ field: "email", value: e.target.value }))
//             }
//           />

//           <select
//             className="vk-form-input vk-form-select"
//             value={form.currency}
//             onChange={(e) => dispatch(setCurrency(e.target.value))}
//             aria-label="Select currency"
//           >
//             {CURRENCIES.map(({ code, label }) => (
//               <option key={code} value={code}>{label}</option>
//             ))}
//           </select>
//         </div>

//         {/* Terms */}
//         <div className="vk-modal-legal">
//           <label className="vk-checkbox-label">
//             <input
//               type="checkbox"
//               checked={form.terms}
//               onChange={(e) =>
//                 dispatch(setBookingField({ field: "terms", value: e.target.checked }))
//               }
//             />
//             <span className="vk-checkbox-custom" />
//             <span>
//               I agree to the{" "}
//               <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>{" "}
//               and acknowledge the{" "}
//               <a href="/waiver" target="_blank" rel="noopener noreferrer">Liability Waiver</a>.{" "}
//               <span className="vk-form-req">*</span>
//             </span>
//           </label>
//         </div>

//         {/* Error */}
//         {(form.error || checkoutError) && (
//           <div className="vk-form-error">
//             <span className="vk-form-error-icon">⚠</span>{" "}
//             {form.error || checkoutError}
//           </div>
//         )}

//         {/* Submit */}
//         <button
//           className={`vk-btn-primary vk-btn-full${loading ? " loading" : ""}`}
//           onClick={handleProceed}
//           disabled={loading || !form.terms || !form.email.trim()}
//         >
//           {loading
//             ? "REDIRECTING TO CHECKOUT..."
//             : `PROCEED TO CHECKOUT ▶ ${sym}${totalPrice}`}
//         </button>

//         <p className="vk-modal-stripe-note">
//           🔒 Secure payment via Stripe · Apple Pay &amp; Google Pay supported.
//           Vegas Karts does not store card data.
//         </p>

//       </div>
//     </div>
//   );
// }


import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  setBookingField,
  setQty,
  setCurrency,
  createCheckoutSession,
  selectBookingForm,
  selectCheckoutStatus,
  selectCheckoutError,
  selectSelectedTour,
} from "../Paneltours/PanelTourSlice/PanelTourSlice";

const MISSION_NAMES = {
  "the-strip" : "THE STRIP",
  downtown    : "DOWNTOWN",
  "red-rock"  : "RED ROCK",
  "lake-lv"   : "LAKE LV",
};

const CURRENCIES = [
  { code: "usd", label: "USD — US Dollar"        },
  { code: "eur", label: "EUR — Euro"              },
  { code: "gbp", label: "GBP — British Pound"     },
  { code: "cad", label: "CAD — Canadian Dollar"   },
  { code: "aud", label: "AUD — Australian Dollar" },
  { code: "inr", label: "INR — Indian Rupee"      },
  { code: "aed", label: "AED — UAE Dirham"        },
];

const CCY_SYMBOL = {
  usd: "$", eur: "€", gbp: "£", cad: "CA$",
  aud: "A$", inr: "₹", aed: "AED ",
};

export default function MissionModal({ savedCallsign = "", savedEmail = "" }) {
  const dispatch      = useDispatch();
  const form          = useSelector(selectBookingForm);
  const tour          = useSelector(selectSelectedTour);
  const status        = useSelector(selectCheckoutStatus);
  const checkoutError = useSelector(selectCheckoutError);

  const loading    = status === "loading";
  const sym        = CCY_SYMBOL[form.currency] ?? "$";
  const totalPrice = tour ? tour.price * form.qty : 0;

  // Pre-fill from driver profile
  useEffect(() => {
    if (savedCallsign && !form.callsign) {
      dispatch(setBookingField({ field: "callsign", value: savedCallsign }));
    }
    if (savedEmail && !form.email) {
      dispatch(setBookingField({ field: "email", value: savedEmail }));
    }
  }, [savedCallsign, savedEmail]); // eslint-disable-line

  // Lock body scroll when modal open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  if (!tour) return null;

  const handleProceed = async () => {
    if (!form.terms) {
      dispatch(setBookingField({
        field : "error",
        value : "Please agree to the Terms of Service and Liability Waiver.",
      }));
      return;
    }
    if (!form.email.trim() || !form.email.includes("@")) {
      dispatch(setBookingField({
        field : "error",
        value : "A valid email address is required.",
      }));
      return;
    }

    const result = await dispatch(createCheckoutSession({
      tourId   : tour.id,
      tourName : MISSION_NAMES[tour.id] || tour.name,
      priceUsd : tour.price,
      qty      : form.qty,
      callsign : form.callsign,
      email    : form.email,
      currency : form.currency,
    }));

    if (createCheckoutSession.fulfilled.match(result)) {
      const { url, internalRef } = result.payload;

      // Store internalRef in sessionStorage so BookingSuccess can look up
      // the booking after FareHarbor redirects back to your success URL.
      // FareHarbor does NOT forward custom query params through their checkout,
      // so sessionStorage is the most reliable handoff mechanism.
      if (internalRef) {
        sessionStorage.setItem("vk_booking_ref", internalRef);
      }

      // Redirect to FareHarbor Lightframe (their hosted checkout page).
      // FareHarbor handles payment collection, confirmation emails, and
      // calendar scheduling. After payment, they redirect to your
      // Dashboard → Settings → Checkout → Redirect URL.
      window.location.href = url;
    }
  };

  return (
    <div
      className="vk-modal-overlay"
      onClick={(e) => e.target === e.currentTarget && dispatch(closeModal())}
    >
      <div className="vk-modal-panel">

        {/* Close */}
        <button
          className="vk-modal-close"
          onClick={() => dispatch(closeModal())}
          aria-label="Close"
        >✕</button>

        {/* Header */}
        <div className="vk-modal-eyebrow">✓ MISSION ACCEPTED</div>
        <h3 className="vk-modal-title">{MISSION_NAMES[tour.id] || tour.name}</h3>

        {/* Price + Qty */}
        <div className="vk-modal-price-row">
          <div className="vk-modal-price">
            {sym}{totalPrice}
            <span className="vk-modal-price-sub"> // PRE-ORDER</span>
          </div>

          <div className="vk-modal-qty-wrap">
            <button
              className="vk-qty-btn"
              onClick={() => dispatch(setQty(form.qty - 1))}
              disabled={form.qty <= 1}
            >−</button>
            <span className="vk-qty-val">{form.qty}</span>
            <button
              className="vk-qty-btn"
              onClick={() => dispatch(setQty(form.qty + 1))}
              disabled={form.qty >= 10}
            >+</button>
            <span className="vk-qty-label">DRIVER{form.qty > 1 ? "S" : ""}</span>
          </div>
        </div>

        {/* Info */}
        <p className="vk-modal-body">
          This is a <strong>pre-order</strong>. You are reserving your slot for{" "}
          <strong>Winter 2026 deployment</strong>. Scheduling will be communicated
          via your driver inbox after launch.
        </p>
        <p className="vk-modal-body">
          You will be redirected to our secure booking partner{" "}
          <strong>FareHarbor</strong> to complete payment. A valid driver's
          license (18+) is required at time of experience. Full refund available
          up to 30 days after purchase.
        </p>

        {/* Form */}
        <div className="vk-modal-form">
          <input
            className="vk-form-input"
            placeholder="CALLSIGN (optional)"
            maxLength={20}
            value={form.callsign}
            onChange={(e) =>
              dispatch(setBookingField({
                field : "callsign",
                value : e.target.value.toUpperCase().replace(/[^A-Z0-9\s_-]/g, ""),
              }))
            }
          />

          <input
            type="email"
            className="vk-form-input"
            placeholder="EMAIL ADDRESS *"
            required
            value={form.email}
            onChange={(e) =>
              dispatch(setBookingField({ field: "email", value: e.target.value }))
            }
          />

          <select
            className="vk-form-input vk-form-select"
            value={form.currency}
            onChange={(e) => dispatch(setCurrency(e.target.value))}
            aria-label="Select currency"
          >
            {CURRENCIES.map(({ code, label }) => (
              <option key={code} value={code}>{label}</option>
            ))}
          </select>
        </div>

        {/* Terms */}
        <div className="vk-modal-legal">
          <label className="vk-checkbox-label">
            <input
              type="checkbox"
              checked={form.terms}
              onChange={(e) =>
                dispatch(setBookingField({ field: "terms", value: e.target.checked }))
              }
            />
            <span className="vk-checkbox-custom" />
            <span>
              I agree to the{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>{" "}
              and acknowledge the{" "}
              <a href="/waiver" target="_blank" rel="noopener noreferrer">Liability Waiver</a>.{" "}
              <span className="vk-form-req">*</span>
            </span>
          </label>
        </div>

        {/* Error */}
        {(form.error || checkoutError) && (
          <div className="vk-form-error">
            <span className="vk-form-error-icon">⚠</span>{" "}
            {form.error || checkoutError}
          </div>
        )}

        {/* Submit */}
        <button
          className={`vk-btn-primary vk-btn-full${loading ? " loading" : ""}`}
          onClick={handleProceed}
          disabled={loading || !form.terms || !form.email.trim()}
        >
          {loading
            ? "REDIRECTING TO FAREHARBOR..."
            : `PROCEED TO CHECKOUT ▶ ${sym}${totalPrice}`}
        </button>

        <p className="vk-modal-stripe-note">
          🔒 Secure payment via FareHarbor · All major cards, Apple Pay &amp; Google Pay supported.
          Vegas Karts does not store card data.
        </p>

      </div>
    </div>
  );
}